import {
    GET_LIST_PROCEDURE,
    GET_SPECIFIC_PROCEDURE,
    UPDATE_SPECIFIC_PROCEDURE,
    CREATE_NEW_PROCEDURE,
    REMOVE_PROCEDURE,
    GET_PROCEDURE_ACTIVE
} from '../actions/types';

/**
 * initial state cho module Procedure
 */
const INIT_STATE = {
    procedureList: [],
    currentProcedure: null,
    procedureActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PROCEDURE: {
            return {
                ...state,
                procedureList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            };
        }

        case GET_PROCEDURE_ACTIVE: {
            return {
                ...state,
                procedureActiveList: action.payload?.data || [],
            };
        }

        case GET_SPECIFIC_PROCEDURE: {
            return { ...state, currentProcedure: action.payload };
        }

        case CREATE_NEW_PROCEDURE: {
            return {
                ...state,
                procedureList: [action.payload, ...state.procedureList],
                procedureActiveList: [action.payload, ...state.procedureActiveList],
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total + 1
                }
            };
        }

        case UPDATE_SPECIFIC_PROCEDURE: {
            const updatedList = state.procedureList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            const updatedActiveList = state.procedureActiveList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            return {
                ...state,
                procedureList: updatedList,
                procedureActiveList: updatedActiveList
            };
        }

        case REMOVE_PROCEDURE: {
            const filteredList = state.procedureList.filter(item => !action.payload.includes(item.id));
            const filteredActiveList = state.procedureActiveList.filter(item => !action.payload.includes(item.id));

            return {
                ...state,
                procedureList: filteredList,
                procedureActiveList: filteredActiveList
            };
        }

        default:
            return { ...state };
    }
};
